

































































import Vue from 'vue';
import * as richiedenteApi from '../../services/richiedente-api';
import { RichiedenteEditViewModel } from '../../types';
import validationRulesMixin from '../../components/mixin/validation-rules-mixin';

export default Vue.extend({
    mixins: [validationRulesMixin],

    components: {},
    props: {
        fullSize: { default: false },
        id: { default: 0 },
    },
    data(): RichiedenteEditViewModel {
        return {
            item: null,
            isValid: false,
        };
    },
    computed: {
        isNew(): boolean {
            return this.item != null && this.item.id === 0;
        },
    },
    methods: {
        async loadData(id: number): Promise<void> {
            if (id > 0) {
                this.item = await richiedenteApi.getByKey(id);
            } else {
                this.setNewItem();
            }
        },
        close() {
            this.$emit('close');
        },
        setNewItem() {
            this.item = {
                id: 0,
                version: 0,
                nome: '',
                cognome: '',
                attivo: true,
                displayName: this.$i18n.t('labels.nuovo').toString(),
            };
        },
        async save() {
            if (!this.item) {
                return;
            }
            let response = null;
            if (this.isNew) {
                response = await richiedenteApi.create(this.item);
            } else {
                response = await richiedenteApi.update(this.item);
            }
            await this.loadData(response.id);
            this.$emit('save', this.item);
        },
    },
    async mounted() {
        await this.loadData(this.id);
        setTimeout(() => {
            this.isValid = (this.$refs.form as HTMLFormElement).validate();
        });
    },
});
